module.exports = __webpack_public_path__ + "img/9788949123301.21135f79.jpg";